import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import format from "date-fns/format";
import { Grid, Typography, Card, Box } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import ShareButton from "../../../shared/components/ShareButton";
import smoothScrollTop from "../../../shared/functions/smoothScrollTop";

const styles = (theme) => ({
  wrapper: {
    maxWidth: "1280px",
    margin: "auto",
  },

  container: {
    padding: "calc(5em + 130px) 2em 5em 2em",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
  },

  video: {
    width: "100%",
    display: "block",
    backgroundSize: "cover !important",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    borderRadius: "24px",
    overflow: "hidden",
    border: "none",

    "& iframe": {
      width: "100%",
      borderRadius: "24px",
    },

    [theme.breakpoints.down("sm")]: {
      "& iframe": {
        height: "400px",
      },
    },

    "@media screen and (max-width: 450px)": {
      "& iframe": {
        height: "300px",
      },
    },
  },

  btnContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
});

function VideoPost(props) {
  const { classes, date, title, content } = props;

  useEffect(() => {
    document.title = `Auralyze.ai- ${title}`;
    smoothScrollTop();
  }, [title]);

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.container}>
        <Typography variant="h3" fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="subtitle">
          {" "}
          {format(new Date(date * 1000), "PPP", {
            awareOfUnicodeTokens: true,
          })}
        </Typography>
        <Box className={classes.video}>{content}</Box>
        {/* <Box className={classes.btnContainer}>
          {["Twitter", "Reddit"].map((type, index) => (
            <Box key={index}>
              <ShareButton
                type={type}
                title="Auralyze.ai"
                description="Check out this amazing article on Auralyze.ai!"
                disableElevation
                variant="contained"
                className="text-white"
                classes={{
                  label: "text-white",
                }}
              />
            </Box>
          ))}
        </Box> */}
      </Box>
    </Box>
  );
}

VideoPost.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  otherArticles: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withStyles(styles, { withTheme: true })(VideoPost);
